import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const Dollar = props => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M10.833 3.90997C10.833 3.5648 10.5532 3.28497 10.208 3.28497C9.86283 3.28497 9.58301 3.5648 9.58301 3.90997H10.833ZM9.58301 4.47997V5.10497H10.833V4.47997H9.58301ZM9.58301 3.90997V4.47997H10.833V3.90997H9.58301Z" fill="currentColor" />;
    t1 = <path d="M10.8105 16V15.375H9.56055V16H10.8105ZM9.56055 16.5613C9.56055 16.9065 9.84037 17.1863 10.1855 17.1863C10.5307 17.1863 10.8105 16.9065 10.8105 16.5613H9.56055ZM9.56055 16V16.5613H10.8105V16H9.56055Z" fill="currentColor" />;
    t2 = <path d="M7.25 12.9484C7.25 13.946 8.05884 14.7548 9.05645 14.7548H10.8629C12.1098 14.7548 13.121 13.7436 13.121 12.4967C13.121 11.2498 12.1098 10.2387 10.8629 10.2387H9.50807C8.26116 10.2387 7.25 9.22751 7.25 7.9806C7.25 6.7337 8.26116 5.72253 9.50807 5.72253H11.3145C12.3121 5.72253 13.121 6.53137 13.121 7.52899" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}</svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default Dollar;